import { PataflagService } from "../../services/pataflag.service";
import { Features } from "../core/pataflag";

export interface cXMLData {
  PrItemTxt: string;
  PoComments: string;
  VendorMaterial: string;
  PrPriceRaw: number;
  PrNetPriceRaw: number;
  PrNetPriceUnit: number;
  PrCurrency: string;
  PrQuantityRaw: number;
  PrQuantityUom: string;
  Supauxid?: string;
}

export const getJsonFromcXML = (xmldata: string): cXMLData[] => {
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(xmldata, "text/xml");
  const items = xmlDoc.getElementsByTagName("ItemIn");
  const htmlNodeArray = Array.from(items);
  const finalData: cXMLData[] = [];

  htmlNodeArray.forEach(item => {
    const descriptionNode = item.getElementsByTagName("Description")[0];
    let shortNameNode: any = "";
    if (item.getElementsByTagName("ShortName").length > 0) {
      shortNameNode = descriptionNode?.removeChild(
        item.getElementsByTagName("ShortName")[0]
      );
    }

    const longDescp = descriptionNode.childNodes[0].nodeValue;
    const shortDescp = shortNameNode
      ? shortNameNode.childNodes[0].nodeValue
      : longDescp;
    
    let vendorMatNumber;
    let supplierPartAuxiliaryId;

    if(PataflagService.getInstance().flag(Features.RC_178357_CAPTURE_POST_SUPPLIER_AUXID_TO_SAP)){
      vendorMatNumber = item.getElementsByTagName(
        "SupplierPartID"
      )[0]?.childNodes[0]?.nodeValue;
      supplierPartAuxiliaryId = item.getElementsByTagName(
        "SupplierPartAuxiliaryID"
      )[0]?.childNodes[0]?.nodeValue;
    }else{
      vendorMatNumber = item.getElementsByTagName(
      "SupplierPartAuxiliaryID"
      )[0]?.childNodes[0]?.nodeValue;
    }

    const quantity = item.getAttribute("quantity");
    const currency = item
      ?.getElementsByTagName("Money")[0]
      ?.getAttribute("currency");
    const unit = item.getElementsByTagName("UnitOfMeasure")[0]?.childNodes[0]
      .nodeValue;
    //const price = item.getElementsByTagName("Money")[0]?.childNodes[0]?.nodeValue;
    const price =
  item.getElementsByTagName("Money")[0]?.childNodes[0]?.nodeValue;

const priceBasisQuantity =
  item
    ?.getElementsByTagName("PriceBasisQuantity")[0]
    ?.getAttribute("quantity");


    if(PataflagService.getInstance().flag(Features.RC_178357_CAPTURE_POST_SUPPLIER_AUXID_TO_SAP)){
      finalData.push({
        PrItemTxt: (shortDescp && shortDescp.length > 40) ? shortDescp.slice(0, 40) : shortDescp,
        PoComments: longDescp,
        VendorMaterial: vendorMatNumber,
        PrPriceRaw: +price,
        PrNetPriceRaw: +price,
        PrNetPriceUnit:
  priceBasisQuantity && +priceBasisQuantity > 0
    ? +priceBasisQuantity
    : 1,
        PrCurrency: currency,
        PrQuantityRaw: +quantity,
        PrQuantityUom: unit,
        Supauxid: supplierPartAuxiliaryId
      });
    }else{
      finalData.push({
        PrItemTxt: (shortDescp && shortDescp.length > 40) ? shortDescp.slice(0, 40) : shortDescp,
        PoComments: longDescp,
        VendorMaterial: vendorMatNumber,
        PrPriceRaw: +price,
        PrNetPriceRaw: +price,
        PrNetPriceUnit:
  priceBasisQuantity && +priceBasisQuantity > 0
    ? +priceBasisQuantity
    : 1,
        PrCurrency: currency,
        PrQuantityRaw: +quantity,
        PrQuantityUom: unit
      });
    }
  });

  return finalData;
};
